import Vue from "vue";
import axios from "axios";
import TcVod from "vod-js-sdk-v6";
import request from "@/utils/request";
import { getVideoInfoById } from "@/api/course";
import { systemSwitch } from "@/api/api";
import { $rrj } from "@/utils/rrjutils";
import OSS from "ali-oss";

// 阿里云OSS断点续传检查点（内存中，刷新丢失）
const checkpoint = {};

// OSS client options
function ossClientOptions(token) {
  // 兼容两种响应结构：token.data.xxx 或直接 token.xxx
  const data = token.data || token;
  return {
    region: "oss-cn-hangzhou",
    accessKeyId: data.AccessKeyId,
    accessKeySecret: data.AccessKeySecret,
    stsToken: data.SecurityToken,
    bucket: "rrjvideo",
    secure: true,
    timeout: 300000,
  };
}

async function getOssClient() {
  // 使用原生 axios，不携带用户参数，以获取通用权限的 STS token
  const token = await axios.get("https://renrenjiang.cn/stsToken");
  const client = new OSS(ossClientOptions(token));
  return client;
}

let isUploadVideoValue = -1;
// 获取上传视频黑名单
async function isUploadVideo() {
  console.log("isUploadVideo");
  if (isUploadVideoValue !== -1) {
    return isUploadVideoValue;
  }
  const user = $rrj.storage.get("_ukit");
  const res = await systemSwitch({
    user_id: user && user.id,
    include: "activity_upload_switch",
  });
  isUploadVideoValue = res.activity_upload_switch;
  return res.activity_upload_switch;
}

isUploadVideo();

// 生成唯一 ID 的辅助函数
function generateUniqueId() {
  return Math.random().toString(36).slice(2, 11); // 示例：随机字符串
}
// 获取腾讯云签名
async function getTcVodClient(upload) {
  const url = `https://api.renrenjiang.cn/api/v3/column_hybrid/source/${upload.type}/createSourceSign`;

  const formData = new FormData();
  formData.append("categoryId", upload.file.categoryId);
  formData.append("title", upload.title);
  const res = await request.post(url, formData);

  if (res.result === "ok") {
    upload.video_id = res.video_id;
    upload.isLimit = false;
  } else {
    const $vm = new Vue();
    $vm.$message.closeAll(); // 关闭所有消息
    $vm.$message.error(res.message || "上传失败，请稍后重试");

    if (res.message === "您的存储空间已达上限") {
      upload.isLimit = true;
    } else {
      upload.isLimit = false;
    }

    return { result: "fail" };
  }

  async function getSignature() {
    return res.sign;
  }

  const tcVod = new TcVod({
    getSignature: getSignature,
  });

  return tcVod;
}

// 文件上传成功提示
function onSuccess({ file, type, id, video_id }, commit) {
  const $vm = new Vue();
  $vm.$notify({
    type: "success",
    title: "上传文件完成",
    message: `文件${file.name}上传成功，请等待转码完成`,
    duration: 3000,
  });

  setTimeout(() => {
    // 关闭所有现有的通知
    $vm.$notify.closeAll();
  }, 5000);

  // 上传成功后，同步更新状态
  if (type === "video") {
    findVideoStatus(id, video_id, commit);
  }
}

function findVideoStatus(id, video_id, commit) {
  console.log("findVideoStatus", id, video_id);
  // 轮询转码状态
  const interval = setInterval(() => {
    getVideoInfoById(video_id).then((res) => {
      if (res.status === 2) {
        commit("updateStatusById", {
          id,
          status: 100,
        });
        clearInterval(interval);
      }
    });
  }, 2 * 60 * 1000); // 每 2 分钟检查一次
}

const uploads = {
  namespaced: true,
  state: {
    selectedFiles: [], // 选中的上传列表
    uploadQueue: [], // 上传队列
    current: {}, // 当前上传成功文件
    isUploadVideo: -1, // 是否是上传视频
    isUploading: {}, // 已经开始上传的id
    isLimit: false,
  },
  mutations: {
    async addFiles(state, files) {
      // 判断是否是黑名单用户
      console.log(isUploadVideoValue, "state.isUploadVideo");
      if (isUploadVideoValue === -1) {
        isUploadVideoValue = await isUploadVideo();
      }

      if (isUploadVideoValue === "0") {
        // 关闭所有现有的通知
        const $vm = new Vue();
        $vm.$message.closeAll(); // 关闭所有消息
        $vm.$message.error("账号上传额度已用尽，升级为高级讲师后可继续上传");
        return;
      }

      // 获取已有文件名集合
      const existingFileNames = new Set(
        state.selectedFiles.map((file) => file.name)
      );
      // 过滤掉已存在的文件
      const newFiles = files
        .filter((file) => !existingFileNames.has(file.name)) // 过滤掉已存在的文件
        .map((file) => ({
          id: generateUniqueId(), // 生成唯一 ID
          ...file,
          process: 0, // 初始化进度为 0
          status: 0, // 初始化状态为待上传
          video: {}, // 初始化视频信息为空对象
        }));
      state.selectedFiles.push(...newFiles); // 使用 push 追加新文件
      console.log("state.selectedFiles", state.selectedFiles);
    },
    setSelectedFiles(state, files) {
      state.selectedFiles = files;
      state.uploadQueue = [];
      state.isUploading = {};
    },
    // 更新文件的上传进度
    updateProcessById(state, { id, process }) {
      // debugger;
      console.log("updateProcessById", id, process);
      const index = state.selectedFiles.findIndex((file) => file.id === id);
      console.log("updateProcessById index", index);
      if (index !== -1) {
        state.selectedFiles[index].process = process;
      }

      console.log("file1=>", state.selectedFiles);
    },
    // 更新文件的上传状态
    updateStatusById(state, { id, status }) {
      console.log("updateStatusById", id, status);
      const index = state.selectedFiles.findIndex((file) => file.id === id);
      if (index !== -1) {
        //   file.progress = progress;
        state.selectedFiles[index].status = status;
      }

      const j = state.uploadQueue.findIndex((file) => file.id === id);
      if (j !== -1) {
        state.uploadQueue[j].status = status;
      }
    },
    // 移除文件
    removeFileById(state, id) {
      // 查找要取消的上传任务
      const upload = state.uploadQueue.find((u) => u.id === id);
      console.log("removeFileById===>", upload);
      if (upload && upload.uploader) {
        try {
          upload.uploader.cancel(); // 调用腾讯云SDK取消上传
          console.log("已取消上传:", id);
        } catch (e) {
          console.error("取消上传失败:", e);
        }
      }

      state.selectedFiles = state.selectedFiles.filter(
        (file) => file.id !== id
      );
      // state.uploadQueue = state.uploadQueue.filter((upload) => upload.id !== id);
    },
    // 添加文件到上传队列
    addToUploadQueue(state, upload) {
      state.uploadQueue.push(upload);
      console.log(state.uploadQueue, "uploadQueue");
    },
    // 从上传队列中移除文件
    removeFromUploadQueue(state, id) {
      state.uploadQueue = state.uploadQueue.filter(
        (upload) => upload.id !== id
      );
    },
    // 更新视频对象
    updateVideoById(state, { id, video }) {
      console.log("updateVideoById", id, video);
      const index = state.selectedFiles.findIndex((file) => file.id === id);
      if (index !== -1) {
        state.selectedFiles[index].video = video;
        state.current = { ...state.selectedFiles[index] };
      }
    },
    // 设置上传限制状态
    setUploadLimit(state, isLimit) {
      console.log("setUploadLimit", isLimit);
      state.isLimit = isLimit;
    },
  },
  actions: {
    cancelUpload({ commit, dispatch }, id) {
      commit("removeFileById", id);
      commit("removeFromUploadQueue", id);
      dispatch("processUploadQueue"); // 手动触发队列处理
    },
    createUpload({ state, commit, dispatch }, { file, id, type = "video" }) {
      // 音频文件列表
      const audioFileFixs = ["mp3", "m4a", "wav", "aac", "wma"];
      const fileFix = file.name.replace(/.+\./, "").toLowerCase(); // 文件后缀

      if (type === "fake_live") {
        // 伪直播：走阿里云OSS
        const stroeName = `mp4live_${id}_${Date.now()}`;
        const storeAs = `/upload_mp4/${stroeName}.${fileFix}`;

        const upload = {
          id: id,
          title: file.name.split(".").slice(0, -1).join("."),
          name: file.name,
          type: "fake_live",
          file,
          storeAs,
          status: 0, // 0待上传
          process: 0,
          client: null,
          retryCount: 0,
        };
        commit("addToUploadQueue", upload);
        // 同时加入 selectedFiles，以便弹窗/面板通过 mapState 监听进度和状态
        const existingIndex = state.selectedFiles.findIndex((f) => f.id === id);
        if (existingIndex === -1) {
          state.selectedFiles.push(upload);
        } else {
          state.selectedFiles.splice(existingIndex, 1, upload);
        }
        dispatch("processUploadQueue");
        return;
      }

      // 原有逻辑：普通视频/音频走腾讯云VOD（保持不变）
      const title = file.name.split(".").slice(0, -1).join(".");
      const isAudio = audioFileFixs.indexOf(fileFix) > -1;

      let upload = {
        id: id, // 生成唯一 ID
        title: title,
        type: isAudio ? "audio" : "video",
        client: null,
        tcVod: null,
        uploader: null,
        file, // 文件
        status: 0, // 0失败, 1上传中,2转码中, 3成功, 4失败， 5成功
      };

      // 添加文件到上传队列
      commit("addToUploadQueue", upload);

      // 开始处理上传队列
      dispatch("processUploadQueue");
    },
    async processUploadQueue({ state, commit, dispatch }) {
      // 每次最多上传两个文件
      const maxConcurrentUploads = 2;
      const activeUploads = state.uploadQueue.filter(
        (upload) => upload.status === 1
      );

      if (activeUploads.length >= maxConcurrentUploads) {
        // 如果当前正在上传的文件数量已经达到最大值，则不启动新的上传
        return;
      }

      // 从队列中取出待上传的文件
      const uploadsToStart = state.uploadQueue
        .filter((upload) => upload.status === 0)
        .slice(0, maxConcurrentUploads - activeUploads.length);

      for (const upload of uploadsToStart) {
        if (state.isUploading[upload.id]) {
          commit("updateStatusById", { id: upload.id, status: 1 });
          continue;
        }
        // 更新文件状态为上传中
        commit("updateStatusById", { id: upload.id, status: 1 });
        // 开始上传
        dispatch("realUpload", upload);

        state.isUploading[upload.id] = true;
        console.log("upload", upload);
      }
    },
    restartUpload({ dispatch }, upload) {
      dispatch("realUpload", upload);
    },
    async realUpload({ commit, dispatch }, upload) {
      if (upload.type === "fake_live") {
        await dispatch("realUploadAliyun", upload);
        return;
      }
      // 腾讯云上传
      let tcVod = upload.tcVod;
      try {
        tcVod = await getTcVodClient(upload);
        // if (tcVod.result === "fail") {
        //   tcVod = await getTcVodClient(upload);
        // }

        console.log("upload++++++++", upload);

        const uploader = tcVod.upload({
          mediaFile: upload.file,
          mediaName: `tx_video_${upload.video_id}_`,
          enableResume: true,
        });

        upload.uploader = uploader;
        console.log("upload==>", upload);

        // 视频上传完成时
        uploader.on("media_upload", async function (info) {
          console.log("media_upload 上传完成", info);

          dispatch("onProgress", {
            bytesUploaded: 1,
            id: upload.id,
          });

          onSuccess(upload, commit);

          const video = await getVideoInfoById(upload.video_id);
          console.log("video", video);

          commit("updateVideoById", { id: upload.id, video: video });

          // 上传完成
          commit("updateStatusById", { id: upload.id, status: 2 });
          // 从上传队列中移除文件
          commit("removeFromUploadQueue", upload.id);
          // 处理上传队列
          dispatch("processUploadQueue");
        });

        // 视频上传进度
        uploader.on("media_progress", function (info) {
          console.log("media_progress", info);

          dispatch("onProgress", {
            bytesUploaded: info.percent,
            id: upload.id,
          });
        });

        uploader
          .done()
          .then(async function (doneResult) {
            console.log("upload success:" + JSON.stringify(doneResult));
          })
          .catch((err) => {
            console.log(err);
            // 更新文件状态为失败
            // commit("updateStatusById", { id: upload.id, status: 4 });
            // 从上传队列中移除文件
            // commit("removeFromUploadQueue", upload.id);
            // 处理上传队列
            // dispatch("processUploadQueue");

            if (upload.isLimit) {
              commit("setUploadLimit", true);
              commit("setSelectedFiles", []);
            } else if (!upload.times || upload.times < 2) {
              if (!upload.times) {
                upload.times = 1;
              } else {
                upload.times++;
              }
              dispatch("restartUpload", upload);
            } else {
              this.$message.error("当前文件上传失败，请移除当前文件");
            }
          });
      } catch (e) {
        console.log("http request error: " + JSON.stringify(e));
        console.log("http request error: " + JSON.stringify(upload));
        // 更新文件状态为失败
        // commit("updateStatusById", { id: upload.id, status: 4 });
        // 从上传队列中移除文件
        // commit("removeFromUploadQueue", upload.id);
        // 处理上传队列
        // dispatch("processUploadQueue");

        // 修改state中isLimit为true
        if (upload.isLimit) {
          commit("setUploadLimit", true);
          commit("setSelectedFiles", []);
        } else if (!upload.times || upload.times < 2) {
          if (!upload.times) {
            upload.times = 1;
          } else {
            upload.times++;
          }
          dispatch("restartUpload", upload);
        } else {
          this.$message.error("当前文件上传失败，请移除当前文件");
        }
      }
    },
    // 处理上传进度
    async realUploadAliyun({ commit, dispatch }, upload) {
      const actId = upload.id;

      const progress = (percentage, cpt) => {
        checkpoint[`act_${actId}`] = cpt;
        if (upload.retryCount > 0) {
          upload.retryCount = 0;
        }
        dispatch("onProgress", {
          bytesUploaded: percentage,
          id: upload.id,
        });
      };

      const options = {
        parallel: 2,
        progress,
      };

      if (checkpoint[`act_${actId}`]) {
        options.checkpoint = checkpoint[`act_${actId}`];
      }

      let client;
      try {
        client = await getOssClient();
        commit("updateStatusById", { id: upload.id, status: 1 });
      } catch (e) {
        console.error("getOssClient error:", e);
        commit("updateStatusById", { id: upload.id, status: 4 });
        return;
      }

      try {
        await client.multipartUpload(upload.storeAs, upload.file, options);

        // 上传成功 → 转码中
        commit("updateStatusById", { id: upload.id, status: 2 });

        // 轮询转码状态（每6秒）
        const timer = setInterval(async () => {
          try {
            const res = await request.get(
              `https://stream.renrenjiang.cn/stream/notice/transcode/status?id=${actId}&preview_mode=2`
            );
            // request.get 已解包 response.data，兼容两种结构
            const result = res.result || (res.data && res.data.result);
            if (result === "Success") {
              commit("updateStatusById", { id: upload.id, status: 3 });
              clearInterval(timer);
            }
          } catch (err) {
            console.error("transcode poll error:", err);
          }
        }, 6000);
      } catch (err) {
        if (client && client.isCancel()) {
          console.log("cancel upload");
          commit("updateStatusById", { id: upload.id, status: 0 });
        } else {
          console.error("upload error:", err);
          // 自动重试
          if (upload.retryCount < 10) {
            upload.retryCount += 1;
            setTimeout(() => {
              dispatch("createUpload", {
                file: upload.file,
                id: actId,
                type: "fake_live",
              });
            }, upload.retryCount * (upload.retryCount + 1) * 1000);
          } else {
            commit("updateStatusById", { id: upload.id, status: 4 });
          }
        }
      }
    },
    onProgress({ state, commit, dispatch }, { bytesUploaded, id }) {
      // 更新上传状态
      console.log("bytesUploaded", bytesUploaded);
      if (bytesUploaded > 1.01) {
        // 上传超过100%，说明有问题，自动重传
        const upload = state.uploadQueue.find((item) => item.id === id);
        dispatch("restartUpload", upload);
      } else {
        const process = (bytesUploaded * 100).toFixed(2);
        commit("updateProcessById", { id, process });
      }
    },
  },
};
export default uploads;
